module.exports = __webpack_public_path__ + "static/media/service-img-06.9db732fb.png";